import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.svg";
import saveAddIcon from "../assets/saveAdd.svg";

function Footer() {
  return (
    <footer className="border-t border-[#E6EAF0] bg-[#F5F7FB] text-[#24303A]">
      {/* Section above footer */}
      <div className="w-full max-w-full">
        <div className="flex flex-col gap-4 bg-[#24303A] px-5 py-8 text-white shadow-sm sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3 sm:items-center">
            <span className="inline-flex h-10 w-10 items-center justify-center" aria-hidden="true">
              <img src={saveAddIcon} alt="" className="h-10 w-10 object-contain" aria-hidden />
            </span>
            <p className="text-[16px] font-bold tracking-wide sm:text-[18px] md:text-[20px]">
              Invite your friends and earn exciting rewards! reach out to our team to participate
            </p>
          </div>

          <div className="flex w-full flex-wrap items-center gap-3 sm:w-auto sm:pr-10">
            <button
              type="button"
              onClick={() => {
                window.location.href = "mailto:admin@femtyz.com";
              }}
              className="w-full rounded-full bg-[#7352C7] px-5 py-2 text-[16px] font-semibold text-white transition sm:w-auto"
            >
              admin@femtyz.com
            </button>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-full px-4 py-8 md:px-6 md:py-10">
        <div className="grid gap-8 sm:grid-cols-3 md:gap-8">
          <div className="max-w-md">
            <div className="flex items-start gap-3">
              <img src={logo} alt="FEMTYZ" className="h-10 w-auto" />
            </div>
            <p className="mt-4 text-[16px] font-normal leading-5 text-[#6E7B86] sm:text-[16px] md:text-[16px]">
              FEMTYZ – Fintech for Groceries
            </p>
            <p className="mt-1 text-[16px] font-normal leading-5 text-[#6E7B86] sm:text-[16px] md:text-[16px]">
              Smarter shopping. Real-time price intelligence. Better savings, every shop.
            </p>
            <p className="mt-4 text-[16px] font-normal leading-5 text-[#6E7B86] sm:text-[16px] md:text-[16px]">
              Compare prices, optimise your basket, and stay in control of your grocery spend – all in one place.
            </p>
          </div>

          <div className="justify-start md:justify-self-center">
            <h3 className="text-[18px] font-semibold text-[#24303A]">
              Explore FEMTYZ
            </h3>
            <nav className="mt-4 space-y-3 text-[16px] font-medium sm:text-[16px] md:text-[16px]">
              {/* <Link className="block text-[#24303A]"
                to="/features"
              >
                Compare Prices
              </Link> */}
              <Link
                className="block text-[#24303A]"
                to="/settings?tab=grocery"
              >
                My Grocery List
              </Link>
              <Link
                className="block text-[#24303A]"
                to="/settings?tab=grocery"
              >
                Smart Basket
              </Link>
              <Link className="block text-[#24303A]"
                to="/top-deals"
              >
                Top Deals
              </Link>
              <Link className="block text-[#24303A]" to="/contact">
                Help &amp; Support
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-[18px] font-semibold text-[#24303A]">
              Company &amp; Trust
            </h3>
            <nav className="mt-4 space-y-3 text-[16px] font-medium sm:text-[16px] md:text-[16px]">
              <Link className="block text-[#24303A]" to="/about">
                About FEMTYZ
              </Link>
              <Link className="block text-[#24303A]" to="/how-it-works">
                How It Works
              </Link>
              <Link className="block text-[#24303A]" to="/data-pricing-transparency">
                Data &amp; Pricing Transparency
              </Link>
              <Link className="block text-[#24303A]" to="/privacy-policy">
                Privacy Policy
              </Link>
              <Link className="block text-[#24303A]" to="/terms">
                Terms of Use
              </Link>
            </nav>
          </div>
        </div>
      </div>

      <div className="bg-[#F5F7FB]">
        <div className="mx-auto w-full max-w-full px-4 py-4 md:px-6">
          <h4 className="text-[18px] font-semibold text-[#24303A]">
            Compliance / Disclaimer
          </h4>
          <p className="mt-2 max-w-5xl text-[16px] font-normal leading-5 text-[#6E7B86] sm:text-[15px] md:text-[16px]">
            Prices and availability are updated regularly but may vary in-store. FEMTYZ provides comparison insights and does not sell products directly.
          </p>
        </div>
      </div>

      <div className="border-t-2 mt-4 border-[#7352C7] bg-[#FFFFFF]">
        <div className="mx-auto max-w-6xl px-4 py-4 text-center text-[15px] leading-relaxed text-[#6E7B86] sm:text-[16px] md:px-6 md:text-[16px]">
          Copyright © {new Date().getFullYear()} | Built for everyday households. Powered by smart data.
        </div>
      </div>
    </footer>
  );
}

export default Footer;